import React from 'react';
import PropTypes from 'prop-types';
import BasicDataPod from '../BasicDataPod';
import Link from '../BasicDataPod/Link';
import Description from '../BasicDataPod/Description';
import EduLogo from '../EduLogo';
import './styles.css';

export default function ImageDataPod({ content, ...rest }) {
  const { eduLogoSrc, eduLogoAlt, eduLogoWidth, eduLogoHeight, text, linkText, linkUrl } =
    content;
  return (
    <BasicDataPod {...rest}>
      <EduLogo
        src={eduLogoSrc}
        alt={eduLogoAlt}
        width={eduLogoWidth}
        height={eduLogoHeight}
      />
      <Description text={text} />
      <Link linkText={linkText} linkUrl={linkUrl} external={true} />
    </BasicDataPod>
  );
}

ImageDataPod.propTypes = {
  header: PropTypes.string,
  content: PropTypes.shape({
    eduLogoSrc: PropTypes.string,
    eduLogoAlt: PropTypes.string,
    eduLogoWidth: PropTypes.number,
    eduLogoHeight: PropTypes.number,
    text: PropTypes.string,
    linkText: PropTypes.string,
    linkUrl: PropTypes.string,
  }),
};
